// File: src/App.js

import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { Toaster } from 'react-hot-toast'; // 1. IMPORT THE TOASTER COMPONENT

function App() {
  return (
    <Router>
      {/* 
        2. PLACE THE <Toaster /> COMPONENT AT THE TOP LEVEL OF YOUR APP.
        This component listens for calls to `toast()` from any page and renders the
        actual notification. It doesn't display anything until a toast is triggered.
      */}
      <Toaster
        position="top-right"
        toastOptions={{
          // Define default options
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          // Default options for specific types
          success: {
            duration: 3000,
            theme: {
              primary: 'green',
              secondary: 'black',
            },
          },
        }}
      />
      
      {/* Your original structure is preserved */}
      <div className="app-container">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;